const SearchBar = ({ searchField, search, searchableColumns, onFieldChange, onSearchChange }) => {
  // Updated searchable fields to match controller
  const defaultSearchableFields = [
    { key: 'jobReqId', label: 'Job Req ID' },
    { key: 'jobTitle', label: 'Job Title' },
    { key: 'companyName', label: 'Company Name' },
    { key: 'jobDescription', label: 'Job Description' },
    { key: 'jobLocation', label: 'Job Location' },
    { key: 'department', label: 'Department' },
    { key: 'qualification', label: 'Qualification' },
    { key: 'companyHRName', label: 'HR Name' },
    { key: 'companyHREmail', label: 'HR Email' },
    { key: 'venue', label: 'Venue' },
    { key: 'passedOutYear', label: 'Passed Out Year' },
    { key: 'interviewType', label: 'Interview Type' },
    { key: 'modeOfInterview', label: 'Interview Mode' }
  ];

  // Use provided searchableColumns or default ones
  const availableColumns = searchableColumns && searchableColumns.length > 0
    ? searchableColumns
    : defaultSearchableFields;

  return (
    <div className="search-bar-container">
      <div className="searchsr-bar">
        <select
          className="select-dropdown"
          onChange={(e) => onFieldChange(e.target.value)}
          value={searchField || "jobTitle"} // Default to jobTitle
        >
          {availableColumns.map((column) => (
            <option key={column.key} value={column.key}>
              {column.label}
            </option>
          ))}
        </select>

        <input
          type="text"
          placeholder={`Search by ${availableColumns.find((col) => col.key === (searchField || "jobTitle"))?.label || "Job Title"}...`}
          value={search || ""}
          onChange={(e) => onSearchChange(e.target.value)}
          className="search-input"
          autoComplete="off"
        />
      </div>
    </div>
  );
};

export default SearchBar;